/* NMI MAINTENANCE: BOOKTHATAPP FRAME STYLING AND WIDTH SUPPORT
Guide: assets/newmakeit-start-here.txt. Keep app hooks, field names and initialization order intact.
*/
(function () {
  'use strict';

  var styleId = 'nmi-bta-minimal-workshop-theme';
  var widgetCss = [
    'html, body, .main-panel { background: #ffffff !important; color: #111111 !important; }',
    'html { color-scheme: light; }',
    'body { margin: 0 !important; font-family: Arial, Helvetica, sans-serif !important; }',
    '.widget-container { width: 100% !important; max-width: none !important; margin: 0 !important; padding: 26px !important; box-sizing: border-box !important; color: #111111 !important; background: #ffffff !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; }',
    '.widget-container > div, .sub-panel.inline, .variant-select, .date-picker-container, .time-slot-radio-button-list, .price-container { width: 100% !important; max-width: none !important; box-sizing: border-box !important; }',
    '.sub-panel, .rdp-months, .rdp-month, .rdp-caption, .rdp-table, .rdp-head, .rdp-tbody { color: #111111 !important; background: #ffffff !important; border-radius: 0 !important; box-shadow: none !important; }',
    '.date-picker-container, .rdp { width: 100% !important; max-width: none !important; color: #111111 !important; background: #ffffff !important; border-radius: 10px !important; box-shadow: none !important; }',
    '.rdp-months, .rdp-month, .rdp-table { width: 100% !important; max-width: none !important; }',
    '.widget-title, .titles, .rdp-caption_label, .rdp-head_cell, .timezone-line, .price-container, .price-container span, .widget-container h3, .widget-container h4, .widget-container label { color: #111111 !important; }',
    '.widget-title { margin: 0 0 14px !important; font-family: "Arial Rounded MT Bold", "Trebuchet MS", Arial, sans-serif !important; font-size: 21px !important; font-weight: 900 !important; text-align: left !important; }',
    '.titles { margin-top: 12px !important; font-size: 13px !important; }',
    '.rdp { margin: 12px auto 14px !important; }',
    '.rdp-day { width: 42px !important; height: 42px !important; color: #111111 !important; background: transparent !important; border: 0 !important; border-radius: 8px !important; }',
    '.rdp-day_disabled { color: #aaaaaa !important; opacity: 1 !important; }',
    '.rdp-day_selected, .rdp-day_selected:hover, .rdp-day_selected:focus { color: #ffffff !important; background: #111111 !important; border-radius: 50% !important; }',
    '.rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):hover, .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):focus { color: #111111 !important; background: #e9e9e9 !important; }',
    '.rdp-nav_button, .widget-container section button { color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 7px !important; box-shadow: none !important; }',
    '.bta-react-select__control { min-height: 44px !important; color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 8px !important; box-shadow: none !important; }',
    '.bta-react-select__single-value, .bta-react-select__input-container, .bta-react-select__indicator { color: #111111 !important; }',
    '.bta-react-select__menu, .bta-react-select__menu-list, .bta-react-select__option { color: #111111 !important; background: #ffffff !important; border-radius: 8px !important; }',
    '.bta-react-select__option--is-focused, .bta-react-select__option--is-selected { color: #111111 !important; background: #d9d9d9 !important; }',
    '.widget-container input:not([type="radio"]), .widget-container select, .widget-container textarea { color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 7px !important; }',
    '.widget-container input[type="radio"] { accent-color: #111111 !important; }',
    '.time-slot-radio-button-list { margin: 14px 0 !important; padding: 0 !important; display: grid !important; grid-template-columns: 1fr !important; gap: 12px !important; }',
    '.time-slot-radio-button-list-element { width: 100% !important; min-height: 76px !important; margin: 0 !important; padding: 14px !important; display: flex !important; align-items: center !important; color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 9px !important; }',
    '.time-slot-radio-button-list-element span { color: #111111 !important; }',
    '.widget-container a { color: #111111 !important; text-decoration: underline !important; }',
    '.timezone-line { width: 100% !important; margin: 18px 0 12px !important; }',
    '.price-container { padding: 10px 0 !important; }',
    '.widget-container .pure-button.fluid { width: 100% !important; min-height: 50px !important; color: #ffffff !important; background: #111111 !important; border: 2px solid #111111 !important; border-radius: 9px !important; box-shadow: none !important; font-weight: 900 !important; }',
    '.widget-container .pure-button.fluid:hover, .widget-container .pure-button.fluid:focus { color: #111111 !important; background: #ffffff !important; }',
    '.ReactModal__Content, .waitlist-modal-form, .confirmation-page { color: #111111 !important; background: #ffffff !important; border-radius: 10px !important; }',
    '*:focus-visible { outline: 3px solid #95c93f !important; outline-offset: 2px !important; }',
    '@media (max-width: 560px) { .widget-container { padding: 18px !important; } .widget-title { font-size: 19px !important; } .rdp-day { width: 38px !important; height: 38px !important; } .time-slot-radio-button-list-element { min-height: 68px !important; } }'
  ].join('\n');

  /* NMI MAINTENANCE: Style an accessible booking iframe without changing its booking or payment data.
  */
  function addThemeToDocument(frame) {
    try {
      var frameDocument = frame.contentDocument || frame.contentWindow.document;
      if (!frameDocument || !frameDocument.head) return false;

      if (!frameDocument.getElementById(styleId)) {
        var style = frameDocument.createElement('style');
        style.id = styleId;
        style.textContent = widgetCss;
        frameDocument.head.appendChild(style);
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  /* NMI MAINTENANCE: Apply the same styling when the app supplies inline iframe HTML.
  */
  function addThemeToSrcdoc(frame) {
    if (frame.dataset.nmiBlackSrcdoc === 'true') return false;

    var source = frame.getAttribute('srcdoc');
    if (!source || source.indexOf(styleId) !== -1 || source.indexOf('</head>') === -1) return false;

    frame.dataset.nmiBlackSrcdoc = 'true';
    frame.setAttribute(
      'srcdoc',
      source.replace('</head>', '<style id="' + styleId + '">' + widgetCss + '</style></head>')
    );
    return true;
  }

  /* NMI MAINTENANCE: Keep the booking form and iframe within their existing product-page container.
  */
  function clampBookingWidth(widget, frame) {
    var form = widget.closest('form');
    var container = widget.querySelector('#bta-widget-container');
    var component = widget.querySelector('[id$="-widget-xcomponent"]');

    if (form) {
      form.style.setProperty('width', '100%', 'important');
      form.style.setProperty('max-width', '100%', 'important');
      form.style.setProperty('min-width', '0', 'important');
    }

    widget.style.setProperty('width', '100%', 'important');
    widget.style.setProperty('max-width', '100%', 'important');
    widget.style.setProperty('min-width', '0', 'important');
    widget.style.setProperty('margin', '18px 0 0', 'important');
    widget.style.setProperty('box-sizing', 'border-box', 'important');
    widget.style.setProperty('overflow', 'hidden', 'important');
    widget.style.setProperty('background', '#ffffff', 'important');
    widget.style.setProperty('border', '1px solid #111111', 'important');
    widget.style.setProperty('border-top-width', '8px', 'important');
    widget.style.setProperty('border-radius', '14px', 'important');

    [container, component, frame].forEach(function (element) {
      if (!element) return;
      element.style.setProperty('width', '100%', 'important');
      element.style.setProperty('max-width', '100%', 'important');
      element.style.setProperty('min-width', '0', 'important');
      element.style.setProperty('box-sizing', 'border-box', 'important');
    });

    frame.style.setProperty('display', 'block', 'important');
    frame.style.setProperty('background', '#ffffff', 'important');
    frame.style.setProperty('border', '0', 'important');
    frame.style.setProperty('border-radius', '0 0 13px 13px', 'important');
  }

  /* NMI MAINTENANCE: Find the booking widget after it loads and apply the existing visual adjustments.
  */
  function prepareBookingArea() {
    var waitlist = document.querySelector('.nmi-workshop-waitlist');
    if (!waitlist) return false;

    var productMeta = waitlist.closest('.product-single__meta');
    if (productMeta) productMeta.classList.add('nmi-workshop-booking-ready');

    var widget = document.querySelector('#bta-product-widget');
    var frame = widget && widget.querySelector('iframe');
    if (!frame) return false;

    clampBookingWidth(widget, frame);

    if (frame.dataset.nmiBlackThemeListener !== 'true') {
      frame.dataset.nmiBlackThemeListener = 'true';
      frame.addEventListener('load', function () {
        addThemeToDocument(frame);
      });
    }

    return addThemeToDocument(frame) || addThemeToSrcdoc(frame);
  }

  /* NMI MAINTENANCE: Start after the document is ready and allow time for the booking app to load.
  */
  function initialize() {
    prepareBookingArea();

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (prepareBookingArea() || attempts >= 60) window.clearInterval(timer);
    }, 250);

    var observer = new MutationObserver(function () {
      prepareBookingArea();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();


/* NEWMAKEIT SHARED WORKSHOP LAYOUT
   Keep this in the theme, outside the editable product descriptions.
   Desktop: overview below photos; dates/details below booking.
   Phones: restore the description's original reading order.
   Dates can grow naturally; no fixed column heights or spacer calculations.
   Supports the current arts, pottery, jewellery, metal, wood, digital and 55+ templates.
*/
(function () {
  'use strict';
  var templates = [
    ['nmi-art', 'nmi-art'], ['nmi-jewel', 'nmi-jewel'],
    ['nmi-forge', 'nmi-forge'], ['nmi-forge-source', 'nmi-forge'],
    ['nmi-digi', 'nmi-digi'], ['nmi-weld', 'nmi-weld'],
    ['nmi-dovetail', 'nmi-dovetail'], ['nmi-finebox', 'nmi-finebox'],
    ['nmi-digitalwood', 'nmi-digitalwood'], ['nmi-teencamp', 'nmi-teencamp'],
    ['nmi-wood101', 'nmi-wood101'], ['nmi-wood102', 'nmi-wood102'],
    ['nmi-c55-product', 'nmi-c55-product'], ['nmi-hand6v2', 'nmi-hand6v2'],
    ['nmi-hand8v2', 'nmi-hand8v2'], ['nmi-onewheelv2', 'nmi-onewheelv2'],
    ['nmi-wheel6', 'nmi-wheel6'], ['nmi-pottery3', 'nmi-pottery3'],
    ['nmi-mug', 'nmi-mug']
  ];

  function installStyles() {
    if (document.getElementById('nmi-shared-workshop-layout')) return;
    var style = document.createElement('style');
    style.id = 'nmi-shared-workshop-layout';
    style.textContent = [
      '.nmi-workshop-layout > .grid__item { min-width: 0; }',
      '.nmi-workshop-layout [data-image-zoom-wrapper] { height: 0 !important; }',
      '.nmi-workshop-stack { display: block !important; width: 100% !important; max-width: 100% !important; min-width: 0 !important; height: auto !important; margin: 30px 0 0 !important; float: none !important; box-sizing: border-box; overflow-wrap: anywhere; }',
      '.nmi-workshop-stack *, .nmi-workshop-stack *::before, .nmi-workshop-stack *::after { box-sizing: border-box; }',
      '.nmi-workshop-stack [class*="schedule-detail"], .nmi-workshop-stack [class*="date-list"] { min-width: 0; overflow-wrap: anywhere; }',
      '.nmi-workshop-return { display: block; margin: 14px 0; padding: 10px 16px; border: 2px solid #1d2b3c; border-radius: 8px; background: white; color: #1d2b3c; font: inherit; font-weight: 700; cursor: pointer; }',
      '.nmi-workshop-return[hidden] { display: none !important; }',
      '@media (min-width: 750px) {',
      'body.template-product #ProductSection-product-template .product-single.nmi-workshop-layout { display: grid !important; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important; grid-template-areas: none !important; align-items: start !important; gap: 0 !important; margin-left: -30px !important; }',
      '.product-single.nmi-workshop-layout::after { display: none !important; }',
      'body.template-product #ProductSection-product-template .product-single.nmi-workshop-layout > .grid__item { display: block !important; width: 100% !important; float: none !important; grid-area: auto !important; padding-left: 30px !important; }',
      'body.template-product #ProductSection-product-template .nmi-workshop-layout .product-single__description { display: block !important; }',
      '.nmi-workshop-stack [class$="-hero"] { grid-template-columns: minmax(0, 1fr) !important; }',
      '.nmi-workshop-stack [class$="-hero-side"] { border-left: 0 !important; border-top: 2px solid currentColor; }',
      '.nmi-workshop-stack [class$="-facts"] { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }',
      '.nmi-workshop-stack [class$="-schedule-body"], .nmi-workshop-stack [class$="-techniques"], .nmi-workshop-stack [class$="-details"], .nmi-workshop-stack [class$="-skills"] { grid-template-columns: minmax(0, 1fr) !important; }',
      '}',
      '@media (max-width: 749px) { .product-single.nmi-workshop-layout { display: block !important; } .nmi-workshop-layout > .grid__item { width: 100% !important; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function repairGallery(gallery) {
    if (gallery.dataset.nmiSharedGallery) return;
    var list = gallery.querySelector('.product-single__thumbnails');
    var links = list && list.querySelectorAll('.product-single__thumbnails-item a');
    if (!links || links.length < 2) return;
    gallery.dataset.nmiSharedGallery = 'ready';
    var main = links[0];
    var button = gallery.querySelector('[class*="main-photo-button"], [class*="main-photo-link"]');
    // Existing description helpers retain their own working button and handlers.
    if (button) return;
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'nmi-workshop-return';
    button.textContent = 'Back to main picture';
    button.hidden = true;
    list.before(button);
    list.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (link && list.contains(link)) button.hidden = link === main;
    });
    button.addEventListener('click', function () {
      main.click();
      button.hidden = true;
      var image = gallery.querySelector('.product-single__media-wrapper:not(.hide)');
      if (image) {
        image.setAttribute('tabindex', '-1');
        image.focus({ preventScroll: true });
      }
    });
  }

  function explicitSide(item) {
    var attribute = Array.from(item.attributes).find(function (attr) {
      return /^data-[\w-]*column$/.test(attr.name) && /^(left|right)$/.test(attr.value);
    });
    if (attribute) return attribute.value;
    if (Array.from(item.classList).some(function (name) { return /(?:-left-column|--left|-stacked-left)$/.test(name); })) return 'left';
    if (Array.from(item.classList).some(function (name) { return /(?:-right-column|--right|-stacked-right)$/.test(name); })) return 'right';
    return null;
  }

  function sectionSide(item) {
    var explicit = explicitSide(item);
    if (explicit) return explicit;
    // Older saved descriptions have no data-column markers. Identify their
    // overview/project/learning sections by the existing semantic CSS classes.
    if (Array.from(item.classList).some(function (name) { return /-(hero|facts|person-place)$/.test(name); })) return 'left';
    if (item.querySelector('[class$="-project"], [class$="-projects"], [class$="-techniques"], [class$="-skills"], [class$="-process"]')) return 'left';
    return 'right';
  }

  function initializeWorkshops() {
    document.querySelectorAll('.product-single').forEach(function (product) {
      var description = product.querySelector('.product-single__description');
      var gallery = product.querySelector('.product-single__media-group');
      if (!description || !gallery) return;
      var template, root;
      templates.some(function (candidate) {
        root = description.querySelector('.' + candidate[0] + ':not(.nmi-workshop-stack)');
        if (root) template = candidate;
        return !!root;
      });
      if (!root) return;
      installStyles();
      product.classList.add('nmi-workshop-layout');
      // Some older descriptions flatten this container with display:contents.
      // Keep the booking and its content together as one independent column.
      description.parentElement.style.setProperty('display', 'block', 'important');
      repairGallery(gallery);
      if (root.dataset.nmiSharedLayout) return;

      // Allow older, working description scripts to keep their own resize
      // listeners. When Shopify removes those scripts, this theme takes over.
      var legacy = Array.from(description.querySelectorAll('script')).some(function (script) {
        return /product-single__media-group/.test(script.textContent) && /matchMedia/.test(script.textContent);
      });
      if (legacy) return;

      var items = Array.from(root.children).filter(function (item) {
        return !/^(STYLE|SCRIPT|TEMPLATE)$/.test(item.tagName);
      });
      if (!items.length) return;
      root.dataset.nmiSharedLayout = 'ready';
      var homes = items.map(function (item) {
        var marker = document.createComment('Workshop section original position');
        item.before(marker);
        return { item: item, marker: marker, side: sectionSide(item) };
      });
      function makeStack(side) {
        var stack = document.createElement('div');
        stack.className = root.className + ' ' + template[1] + '-column ' + template[1] + '-' + side + '-column nmi-workshop-stack';
        stack.dataset.nmiWorkshopSide = side;
        return stack;
      }
      var left = makeStack('left');
      var right = makeStack('right');
      var desktop = window.matchMedia('(min-width: 750px)');
      function arrange() {
        if (!root.isConnected) {
          left.remove(); right.remove();
          desktop.removeEventListener('change', arrange);
          return;
        }
        if (desktop.matches) {
          gallery.appendChild(left);
          description.before(right);
          homes.forEach(function (home) { (home.side === 'left' ? left : right).appendChild(home.item); });
        } else {
          homes.forEach(function (home) { home.marker.after(home.item); });
          left.remove(); right.remove();
        }
      }
      arrange();
      desktop.addEventListener('change', arrange);
    });
  }
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', initializeWorkshops, { once: true });
    window.addEventListener('load', initializeWorkshops, { once: true });
  } else {
    initializeWorkshops();
  }
  document.addEventListener('shopify:section:load', initializeWorkshops);
})();
